import React from "react";
import "./AppMajia.css";
import LogoSvg from "./assets/logo.png";
import MarhSvg from "./assets/mark.png";
import XSvg from "./assets/x.svg";
import TelegramSvg from "./assets/telegram.svg";

const AppMajia = () => {
  return (
    <div className="App">
      <header>
        <img src={LogoSvg} alt="" />
      </header>
      <div className="mark">
        <img src={MarhSvg} alt="" />
        <p className="policy">Privacy Policy</p>
        <p className="desc">
          ParoBit values ​​the privacy rights of users and promises that it will
          not collect or share any of your personal privacy data. The data
          generated by your use of this software will be saved entirely on your
          own device, and will not be uploaded to any third- party server. We
          will not access, collect or disclose any of your personal privacy
          information.
        </p>
      </div>
      <div className="btm">
        <div className="con">
          <a
            href="https://twitter.com/parobit"
            target="_blank"
            rel="noreferrer"
          >
            <img src={XSvg} alt="" />
          </a>
          <a href="https://t.me/Parobitcn" target="_blank" rel="noreferrer">
            <img src={TelegramSvg} alt="" />
          </a>
        </div>
        <p className="email">
          <span>Customer support email:</span>
          <span>paro_support@parobit.com</span>
        </p>
        <p className="foot">@2024 FULAN (HONG KONG) TRADING CO., LIMITED </p>
      </div>
    </div>
  );
};

export default AppMajia;
